import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/materials`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const saveSettings = body => axios.put(`${base}/settings`, body, headers());
export const searchArticles = body => axios.post(`${base}/articles/search`, body, headers());
export const getArticle = id => axios.get(`${base}/articles/${id}`, headers());
export const createArticle = body => axios.post(`${base}/articles`, body, headers());
export const updateArticle = (id, body) => axios.put(`${base}/articles/${id}`, body, headers());
export const deleteArticle = id => axios.delete(`${base}/articles/${id}`, headers());
export const linkInventory = (id, body) =>
  axios.post(`${base}/articles/${id}/inventory`, body, headers());
export const offerItems = lines => axios.post(`${base}/offer-items`, { lines }, headers());
export const offerMargin = id => axios.get(`${base}/offers/${id}/margin`, headers());

export const listSuppliers = () => axios.get(`${base}/suppliers`, headers());
export const createSupplier = body => axios.post(`${base}/suppliers`, body, headers());
export const updateSupplier = (id, body) => axios.put(`${base}/suppliers/${id}`, body, headers());
export const deleteSupplier = id => axios.delete(`${base}/suppliers/${id}`, headers());

export const listImports = () => axios.get(`${base}/imports`, headers());
export const getImport = id => axios.get(`${base}/imports/${id}`, headers());
export const startImport = ({ supplier, encoding, files }, onUploadProgress) => {
  const body = new FormData();
  body.append("supplier", supplier);
  body.append("encoding", encoding || "auto");
  files.forEach(file => body.append("files", file, file.name));
  return axios.post(`${base}/imports`, body, { ...headers(), onUploadProgress });
};

export const listTextBlocks = kind =>
  axios.get(`${base}/text-blocks${kind ? `?kind=${encodeURIComponent(kind)}` : ""}`, headers());
export const createTextBlock = body => axios.post(`${base}/text-blocks`, body, headers());
export const updateTextBlock = (id, body) =>
  axios.put(`${base}/text-blocks/${id}`, body, headers());
export const deleteTextBlock = id => axios.delete(`${base}/text-blocks/${id}`, headers());

export const openShopSession = body => axios.post(`${base}/ids/sessions`, body, headers());
export const listBaskets = () => axios.get(`${base}/ids/baskets`, headers());
export const getBasket = id => axios.get(`${base}/ids/baskets/${id}`, headers());
export const importBasket = (id, body) =>
  axios.post(`${base}/ids/baskets/${id}/import`, body, headers());

export const listProjects = () => axios.get(`${base}/projects`, headers());
export const listBookings = query =>
  axios.get(`${base}/bookings?${new URLSearchParams(query || {}).toString()}`, headers());
export const createBooking = body => axios.post(`${base}/bookings`, body, headers());

/**
 * IDS Connect: posts the shop form (login, action, HOOKURL) from the browser in a new tab, the
 * way the wholesaler's shop expects it. The shop later posts the basket back to our API.
 */
export const postToShop = form => {
  const element = document.createElement("form");
  element.method = form.method || "POST";
  element.action = form.url;
  element.target = "_blank";
  element.acceptCharset = "UTF-8";
  Object.entries(form.fields || {}).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value ?? "";
    element.appendChild(input);
  });
  document.body.appendChild(element);
  element.submit();
  element.remove();
};

// The catalog meta (settings, suppliers, permissions) is shared by the page and the offer
// editor's tools; one request per page view. Null when the user may not use the catalog.
let metaPromise = null;
export const loadMeta = ({ refresh = false } = {}) => {
  if (!metaPromise || refresh) {
    metaPromise = getMeta()
      .then(res => res.data.data)
      .catch(error => {
        metaPromise = null;
        if ([401, 403].includes(error?.response?.status)) return null;
        throw error;
      });
  }
  return metaPromise;
};
